import React, { useState, useEffect } from "react";
import Countdown from "react-countdown";
import { Timer } from "./style";
import { memo } from "react";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { getChainDataByChainId } from "../../../utils";

function PoolTimer() {
  const [targetDate, setTargetDate] = useState(0);
  const countdownRef = useRef(null);
  const { networkIdFromURL } = useSelector((state) => state.global);
  
  const { endBlock, currentBlockNO } = useSelector(
    (state) => state.global.poolDetailsFromFactory
  );
  const timer = async () => {
    let chainData = getChainDataByChainId(networkIdFromURL)
    let blockTimeInSec = chainData?.blockTime
    const estimatedTime = (endBlock - currentBlockNO) * blockTimeInSec * 1000;
    if (estimatedTime) {
      setTargetDate(estimatedTime);
    } else {
      setTargetDate(0);
    }
  };

  useEffect(() => {
    if (targetDate > 0 && countdownRef?.current) {
      countdownRef.current?.start();
    }
  }, [targetDate]);

  useEffect(() => {
    timer();
  }, [networkIdFromURL, endBlock, currentBlockNO]);

  return (
    <Countdown
      date={Date.now() + targetDate}
      ref={countdownRef}
      renderer={renderer}
    />
  );
}

export default memo(PoolTimer);

// Renderer callback with condition
const renderer = ({ days, hours, minutes, seconds }) => {
  return (
    <Timer>
      <div className="date flex">
        <span className="value text">{days}</span>{" "}
        <p className="unit MediumText subText2 text-weak">Days</p>
      </div>

      <span className="colon text-weak">:</span>

      <div className="date flex">
        <span className="value text">{hours}</span>{" "}
        <p className="unit MediumText subText2 text-weak">Hours</p>
      </div>

      <span className="colon text-weak">:</span>

      <div className="date flex">
        <span className="value text">{minutes}</span>{" "}
        <p className="unit MediumText subText2 text-weak">Min's</p>
      </div>

      <span className="colon text-weak">:</span>

      <div className="date flex">
        <span className="value text color">{seconds}</span>{" "}
        <p className="unit MediumText subText2 text-weak">Sec's</p>
      </div>
    </Timer>
  );
};
